<div class="splash-container">
    <ng-container [ngSwitch]="currentSection">
        <lgv-about-you-section class="section-body" *ngSwitchCase="StepSection.AboutYou"
            (sectionChange)="goToSection($event)" [specificStep]="specificStep"></lgv-about-you-section>
        <lgv-property-section class="section-body" *ngSwitchCase="StepSection.Property"
            (sectionChange)="goToSection($event)" [specificStep]="specificStep"></lgv-property-section>
        <lgv-pre-approval-section class="section-body" *ngSwitchCase="StepSection.PreApproval"
            (sectionChange)="goToSection($event)" [specificStep]="specificStep"></lgv-pre-approval-section>
    </ng-container>
</div>